export const TaxRoute = {
  PROBATE_TAX_CALCULATOR: {
    name: 'probate-tax-calculator',
    path: 'probate-tax-calculator'
  },
  PROBATE_TAX_CALCULATOR_EMBED: {
    name: 'probate-tax-calculator-embed',
    path: 'probate-tax-calculator-embed'
  },
  PROBATE_TAX_REPORT: {
    name: 'probate-tax-report',
    path: 'probate-tax-report'
  },
  PROBATE_TAX_REPORT_EMBED: {
    name: 'probate-tax-report-embed',
    path: 'probate-tax-report-embed'
  },
  CALIFORNIA_PROBATE_CALCULATOR: {
    name: 'california-probate-calculator',
    path: 'california-probate-calculator'
  },
  CALIFORNIA_PROBATE_CALCULATOR_EMBED: {
    name: 'california-probate-calculator-embed',
    path: 'california-probate-calculator-embed'
  },
  CALIFORNIA_BOND_CALCULATOR: {
    name: 'california-bond-calculator',
    path: 'california-bond-calculator'
  },
  CALIFORNIA_BOND_CALCULATOR_EMBED: {
    name: 'california-bond-calculator-embed',
    path: 'california-bond-calculator-embed'
  },
  BRITISH_COLUMBIA_PROBATE_CALCULATOR: {
    name: 'british-columbia-probate-calculator',
    path: 'british-columbia-probate-calculator'
  },
  BRITISH_COLUMBIA_PROBATE_CALCULATOR_EMBED: {
    name: 'british-columbia-probate-calculator-embed',
    path: 'british-columbia-probate-calculator-embed'
  }
};
